// extracted by mini-css-extract-plugin
module.exports = {"root":"ChoiceImage_root__3M9j4"};